<script lang="tsx">
import { defineComponent, watch, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Timeline } from 'ant-design-vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import StepLaunch from './StepLaunch.vue'
import StepResolve from '../common/StepResolve.vue'
import StepReject from '../common/StepReject.vue'
import CardBox1 from '../../CardBox1.vue'
import TlDetailField from '../common/TlDetailField.vue'
import { useFetch } from '@/hooks/useFetch'
import { API_JT_PROJ_DETAIL } from '@/api/jtProj'

const [name] = createNamespace('TimelineDetailFundAudit')
enum STATUS_TYPE {
  RESOLVE = '通过',
  REJECT = '驳回'
}
export default defineComponent({
  name,
  props: {
    record: {
      type: Object as PropType<any>
    },
    projectId: {
      type: String as PropType<string>
    }
  },
  setup(props) {
    const renderItem = (item: any, index: number) => {
      const isFirst = index === 0
      switch (item.type) {
        case STATUS_TYPE.REJECT:
          return <StepReject record={item} />
        case STATUS_TYPE.RESOLVE:
          return <StepResolve record={item} />
        default:
          return <StepLaunch record={item} isRenew={!isFirst} />
      }
    }
    const { loading, result, fetchData } = useFetch({
      getFn: API_JT_PROJ_DETAIL,
      isShallow: true
    })
    watch(
      () => props.projectId,
      id => {
        if (id) {
          fetchData(id)
        }
      },
      { immediate: true }
    )
    return () => (
      <>
        <div class='mb-32'>
          <CardBox1 title='关联文件' loading={loading.value}>
            <TlDetailField label='规划红线'>
              <FileDisplayNormals files={result.value?.redLineFiles ?? []} colAttrs={{ span: 12 }} />
            </TlDetailField>
            <TlDetailField label='启动依据'>
              <FileDisplayNormals files={result.value?.basisFiles ?? []} colAttrs={{ span: 12 }} />
            </TlDetailField>
          </CardBox1>
        </div>
        <Timeline>{props.record?.his?.map(renderItem)}</Timeline>
      </>
    )
  }
})
</script>
